<template>
    <div class="text-center" v-if="!is_data_ready">
        <span class="loader"></span>
    </div>
    <div class="aside-box" v-else-if="upcomingMatches.length">
        <strong class="h2 text-uppercase">upcoming matches</strong>
        <ul class="info-match-list">
            <li v-for="match in upcomingMatches" :key="match.id" >
              <span v-if="match.team1.name!='TBA' && match.team2.name!='TBA'">
                <router-link :to="{ name: 'matchDetail.Scorecard', params: { match: match.slug } }">
                    <div class="info-match-list-head">
                        <span class="info-match-type">{{ match.matchtype }}</span>
                        <span class="match-timing">{{ match.gmt_datetime | formatDate }}</span>
                    </div>
                    <ul class="team-info">
                        <li>
                            <span class="team-info-name">{{ match.team1.name }}</span>
                            <span class="team-info-score">-</span>
                        </li>
                        <li>
                            <span class="team-info-name">{{ match.team2.name }}</span>
                            <span class="team-info-score">-</span>
                        </li>
                    </ul>
                </router-link>
            </span>
            <span v-else>
                <div class="info-match-list-head">
                    <span class="info-match-type">{{ match.matchtype }}</span>
                    <span class="match-timing">{{ match.gmt_datetime | formatDate }}</span>
                </div>
                <ul class="team-info">
                    <li>
                        <span class="team-info-name">{{ match.team1.name }}</span>
                        <span class="team-info-score">-</span>
                    </li>
                    <li>
                        <span class="team-info-name">{{ match.team2.name }}</span>
                        <span class="team-info-score">-</span>
                    </li>
                </ul>
                </span>
            </li>
        </ul>
    </div>
</template>

<script>
import moment from 'moment'
    export default {
        name: 'upcomingMatches',

        data() {
            return {
                upcomingMatches: []
            }
        },

        jsonld() {

            if (isServer)
                return {
                    "@context": "http://schema.org",
                    "@graph": []
                }

            if (!this.upcomingMatches)
                return

            let events = [];
            this.upcomingMatches.forEach((match) => {
                events.push(
                        {
                            "@type": "SportsEvent",
                            "name": match.team1.name + " VS " + match.team2.name,
                            "description": match.team1.name + " VS " + match.team2.name + " - " + match.matchno,
                            "url": process.env.BASE_URL + "match/" + match.slug + "/teams",
                            "eventStatus": "http://schema.org/EventScheduled",
                            "eventAttendanceMode": "http://schema.org/OfflineEventAttendanceMode",
                            "startDate": moment(match.gmt_datetime).format('YYYY-MM-DD HH:MM'),
                            "endDate": moment(match.gmt_datetime).format('YYYY-MM-DD'),
                            "image": "https://planetcricket.com/public/images/logo1280x720.png",
                            "organizer": {
                                "@type": "Organization",
                                "name":  "ICC",
                                "url": process.env.BASE_URL + "match/" + match.slug + "/teams",
                            },
                            "performer": {
                                "@type": "Thing",
                                "name": match.team1.name + " VS " + match.team2.name,
                            },
                            "competitor": [
                                {
                                    "@type": "SportsTeam",
                                    "name": match.team1.name,
                                    "image": match.team1.flag
                                },
                                {
                                    "@type": "SportsTeam",
                                    "name": match.team2.name,
                                    "image": match.team2.flag
                                }
                            ],
                               "location": {
                                "@type": "Place",
                                "name":"NaN",
                                "address": {
                                    "@type": "PostalAddress",
                                    "name":"NaN",
                                }
                            }
                        }
                )
            });
            return {
                "@context": "http://schema.org",
                "@graph": events
            };

        },

        serverPrefetch() {
            if (this.$store.state.runSsr) {
                return this.main();
            }
        },
        mounted() {
            this.main();
        },
        methods: {
            main() {
                return this.$axios
                        .get(this.$MATCH_UPCOMING_API.replace(':match', this.$route.params.match))
                        .then(response => {
                            this.is_data_ready = true
                            this.upcomingMatches = response.data.result.matches || []
                        })
                        .catch(error => {
                            console.log(error);
                            this.is_data_ready = true
                        })
            }
        }
    }
</script>

